import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useCallback, useContext } from 'react';
import accessToken from '|/helpers/access-token';

const useEventHelper = () => {
  const { trackEvent } = useContext(AnalyticsContext);

  const sendLoadEvent = useCallback(
    (success: boolean, metadata?: {}) => {
      trackEvent('pp_load', {
        url: window.location.pathname,
        userId: accessToken?.().user.user_id,
        successEvent: success,
        metadata: metadata || {},
        devicePlatform: 'web'
      });
    },
    [trackEvent]
  );

  const sendCompleteEvent = useCallback(
    (success: boolean | string, metadata?: {}) => {
      trackEvent('pp_complete', {
        url: window.location.pathname,
        userId: accessToken?.().user.user_id,
        successEvent: success,
        metadata: metadata || {},
        devicePlatform: 'web'
      });
    },
    [trackEvent]
  );

  const sendEvent = useCallback(
    (eventName: string, metadata?: {}) => {
      trackEvent(eventName, {
        url: window.location.pathname,
        userId: accessToken?.().user.user_id,
        metadata: metadata || {},
        devicePlatform: 'web'
      });
    },
    [trackEvent]
  );

  const sendClickEvent = useCallback(
    (analyticsId: string) => {
      trackEvent('pp_click', {
        analyticsId
      });
    },
    [trackEvent]
  );

  return {
    trackEvent,
    sendLoadEvent,
    sendCompleteEvent,
    sendEvent,
    sendClickEvent
  };
};

export default useEventHelper;
